'use client';

import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { ReferralKeys } from './keys';
import { ReferralCode } from './types';
import { sendReferralCode } from './services';
export function useReferralCode(props: ReferralCode['Props']): UseMutationResult<ReferralCode['Response'], Error, ReferralCode['Payload'], unknown> {
  return useMutation({
    mutationFn: payload => sendReferralCode(payload),
    mutationKey: [ReferralKeys],
    onSuccess: () => {
      if (props.onSuccess) {
        props.onSuccess();
      }
    }
  });
}